import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectPortfolio } from "@planzone/dto";
import {
  useEditProjectPortfolio,
  useRetrieveCurrentPlanzone,
  useZonesProjectsRetrieval,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolioEdition({ cancel, portfolio }: Props) {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState<ProjectPortfolio>(portfolio);
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    projects,
    isRequestPending: isProjectsRequestPending,
    isRequestSuccess: isProjectsRequestSuccess,
    isRequestFailure: isProjectsRequestFailure,
    retrieveZonesProjects,
  } = useZonesProjectsRetrieval();
  const { isRequestPending, error, editProjectPortfolio } =
    useEditProjectPortfolio(portfolio);

  React.useEffect(() => {
    !isProjectsRequestPending &&
      !isProjectsRequestSuccess &&
      !isProjectsRequestFailure &&
      retrieveZonesProjects(planzone);
  }, []);

  return (
    <Modal
      header={t("projectPortfolioEdition.title")}
      className={styles.projectPortfolioEdition}
      close={cancel}
    >
      <form
        className={styles.form}
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending &&
            editProjectPortfolio({
              planzone,
              portfolio,
              nextPortfolio: formData,
            });
        }}
      >
        <div className={styles.main}>
          <div className={styles.form}>
            <Form
              projects={projects}
              formData={formData}
              error={error}
              editForm={setFormData}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("projectPortfolioEdition.cancel")}
          </Button>
          <Button type="submit" status={isRequestPending ? "pending" : "none"}>
            {t("projectPortfolioEdition.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { ProjectPortfolioEdition };
